// mission-worktree-excludes.ts
//
// Split out of mission-workspace.ts (review 06g M1, ≤ 200 lines): the exact
// ignore entries of a mission worktree, the `.gitignore` writer, and the
// legacy `.avatar-session.lock` detector. Re-exported from mission-workspace.ts.
import { promises as fs } from "node:fs";
import { join } from "node:path";
import { pathExists } from "../filesystem-helpers.js";

/**
 * Ignore entries CHÍNH XÁC của worktree mission — không hơn không kém (test 45).
 *
 * `.avatar-session.lock*` phải ignore được để không lỡ commit, NHƯNG sự XUẤT HIỆN của
 * nó ở gốc worktree lại là BẰNG CHỨNG worker đã thử mutate git (§9.4) ⇒ verifier xếp
 * loại vi phạm policy, KHÔNG âm thầm dọn.
 */
// `/.claude/state/` (Bug E, dogfood vòng 4): writer DUY NHẤT dưới thư mục này
// là autopilot-binding-file-writer.ts (controller-owned) — không ticket nào
// được đụng qua `allowed_paths`. Thiếu trong `.gitignore`, một binding sót lại
// từ attempt `contract_error` sẽ lọt `git ls-files --others` rồi bị `run` sau
// quét vào bootstrap commit, đọc thành scope violation giả. Xem
// controller-owned-paths.ts (lọc phía verifier, cùng mục đích).
export const MISSION_IGNORE_ENTRIES = [
  "/.avatar/attempt-output/",
  "/.avatar/status.html",
  "/.avatar-session.lock*",
  "/.claude/state/",
] as const;

/**
 * Ghi ignore vào `.gitignore` ở GỐC WORKTREE (không phải per-worktree
 * `info/exclude` — ĐO ĐƯỢC 2026-09-09: git chỉ đọc bản ở common dir, dùng
 * bản đó lại vi phạm F09 vì file nằm trong `.git` của người dùng). File này
 * KHÔNG được commit — hạ tầng mission, chỉ sống trong worktree.
 *
 * Exported (không chỉ gọi từ createMissionWorkspace) để fix dedupe (dogfood
 * 260925) có unit test trực tiếp.
 */
export async function writeWorktreeExcludes(worktreePath: string): Promise<void> {
  const gitignorePath = join(worktreePath, ".gitignore");
  const existing = (await pathExists(gitignorePath))
    ? await fs.readFile(gitignorePath, "utf8")
    : "";
  // Dedupe against a seed `.gitignore` that already has one of our entries
  // (bug found dogfooding 2026-09-25) — whole-line compare, cosmetic but cheap.
  const existingLines = new Set(existing.split("\n"));
  const toAppend = MISSION_IGNORE_ENTRIES.filter((e) => !existingLines.has(e));
  if (toAppend.length === 0) return;
  const block = `${toAppend.join("\n")}\n`;
  const next =
    existing === "" || existing.endsWith("\n") ? existing + block : `${existing}\n${block}`;
  await fs.writeFile(gitignorePath, next, "utf8");
}

/**
 * `.avatar-session.lock` ở GỐC worktree = worker đã thử mutate git ⇒ VI PHẠM POLICY,
 * không phải file ứng dụng. Không tự dọn: sự tồn tại của nó là tín hiệu (§9.4).
 */
export async function detectLegacySessionLockViolation(
  worktreePath: string,
): Promise<{ violation: boolean; files: string[] }> {
  const names = await fs.readdir(worktreePath).catch(() => [] as string[]);
  const files = names.filter(
    (n) => n === ".avatar-session.lock" || n.startsWith(".avatar-session.lock.tmp."),
  );
  return { violation: files.length > 0, files };
}
